import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import { Box, Chip, IconButton, Row } from 'seagull';
import { CloseCross } from 'seagull/icons/essentials';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
export const GetUnknownPredicateChipTID = (parentTestId)=>getTestIds(parentTestId);
export const UnknownPredicateChip = (param)=>{
    let { testId, fieldName, onRemove } = param;
    const { UnknownPredicateChipTestIds } = useMemo(()=>GetUnknownPredicateChipTID(testId), [
        testId
    ]);
    const { t } = useLocaleKeys('pages.draftsDashboard.aiSearch');
    return /*#__PURE__*/ _jsx(Box, {
        testId: UnknownPredicateChipTestIds.Root(),
        children: /*#__PURE__*/ _jsxs(Row, {
            alignItems: "center",
            gap: 4,
            children: [
                /*#__PURE__*/ _jsx(Chip, {
                    testId: UnknownPredicateChipTestIds.Chip(),
                    label: t.unknownPredicateLabel({
                        field: fieldName
                    })
                }),
                /*#__PURE__*/ _jsx(IconButton, {
                    testId: UnknownPredicateChipTestIds.Remove(),
                    bi: {
                        name: 'drafts_ai_search_chip_remove_unknown'
                    },
                    onClick: onRemove,
                    size: "small",
                    children: /*#__PURE__*/ _jsx(CloseCross, {
                        size: 12
                    })
                })
            ]
        })
    });
};
